import { createSelector } from '@reduxjs/toolkit'

import { I_USER_BANK_STATE } from './TYPES'

export const SLICE_NAME = 'userBank'

const select = (state: any): I_USER_BANK_STATE => state[SLICE_NAME]

export const getUserBankReducer = createSelector(select, reducer => reducer)
